// passing the path into variables

const banner1 = '/assets/chilebus/Home/ChileBus-Website-Home-Slide-MainBanner.png';

const destination1 = '/assets/chilebus/destinations/dest-01.svg';
const destination2 = '/assets/chilebus/destinations/dest-02.svg'
const destination3 = '/assets/chilebus/destinations/dest-03.svg'
const destination4 = '/assets/chilebus/destinations/dest-04.svg'
const destination5 = '/assets/chilebus/destinations/dest-05.svg'
const destination6 = '/assets/chilebus/destinations/dest-06.svg'
const destination7 = '/assets/chilebus/destinations/dest-07.svg'

const banner = [banner1];

const destination = [destination1, destination2, destination3, destination4, destination5, destination6, destination7];

const chilebusSlides = {
	banner,
	destination,
};

export default chilebusSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/chilebusSlides.js